import { combineReducers } from 'redux';

import screenReducer from './reducers/universal/screenReducer';
import singleImageScene from './reducers/singleImage/singleImageSceneReducer';
import panelToggle from './reducers/multiImage/panelToggleReducer';
import panels from './reducers/multiImage/comicsPanelReducer';
import buttons from './reducers/universal/buttonsReducer';
import animation from './reducers/universal/animationsReducer';
import carousel from './reducers/universal/carouselReducer';
import curriculum from './reducers/universal/curriculumReducer';
import scrollView from './reducers/text/scrollViewReducer';
import progress from './reducers/universal/progressReducer';
import header from './reducers/universal/headerReducer';
import onboarding from './reducers/universal/onboardingReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  singleImageScene,
  panelToggle,
  panels,
  buttons,
  animation,
  carousel,
  curriculum,
  scrollView,
  progress,
  header,
  onboarding,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
